import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Alert.tsx.esbuild-plugin-linaria.css';
import { css, cx } from '@linaria/core';
import { COLOR_ALERT_BACK, COLOR_ALERT_SHADOW } from '../colors';
export const Alert = ({
  message,
  className
}: {
  message: string;
  className?: string;
}) => <p class={cx("pnxw7ca", className)}>
    {message}
  </p>;